import { buttonVariants, cn, Container, Section } from '@resolute/ui';
import { Link } from 'react-router-dom';


import { Reveal } from '@/components/motion/reveal';

export function HomeCta() {
  return (
    <Section spacing="md">
      <Container>
        <Reveal className="relative overflow-hidden rounded-xl bg-primary px-6 py-10 text-center text-primary-foreground sm:px-12 sm:py-14">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 bg-[radial-gradient(50%_80%_at_50%_0%,hsl(var(--secondary)/0.35),transparent)]"
          />
          <h2 className="relative mx-auto max-w-2xl font-display text-display-sm font-semibold tracking-tight text-primary-foreground">
            Talk to an advisor who works for you.
          </h2>
          <p className="relative mx-auto mt-4 max-w-xl text-primary-foreground/80">
            Share what you&apos;re looking for and we&apos;ll shortlist verified options, arrange
            visits and model the numbers — no spam, no pressure.
          </p>
          <div className="relative mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/contact"
              className={cn(buttonVariants({ variant: 'secondary', size: 'lg' }))}
            >
              Book a consultation
            </Link>
            <Link
              to="/contact"
              className="inline-flex h-12 items-center justify-center rounded border border-primary-foreground/30 px-7 text-base font-medium text-primary-foreground transition-colors duration-fast ease-out-expo hover:bg-primary-foreground/10"
            >
              Talk to an advisor
            </Link>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
